import moment from 'moment';
import { fillArrayWithNumbers } from './arrayHelpers';

export const dayOfMonth = [
  'DD',
  ...fillArrayWithNumbers(1, 31),
];

export const Months = [
  'MM',
  ...moment.months(),
];

const minAge = 16;
const maxAge = 100;
const currentYear = moment().format('YYYY');
const firstYear = currentYear - maxAge;
const yearsSpan = moment().format('YYYY') - firstYear - minAge + 1;
const currentYearsSpan = maxAge + 1;

export const Years = [
  'YYYY',
  ...fillArrayWithNumbers(firstYear, yearsSpan).reverse(),
];

export const NoMinAgeYears = [
  'YYYY',
  ...fillArrayWithNumbers(firstYear, currentYear - firstYear + 1).reverse(),
];

export const YearsFromCurrent = [
  'YYYY',
  ...fillArrayWithNumbers(firstYear, currentYearsSpan).reverse(),
];

export const formatYear = (year) => {
  let strYear = '';
  if (year > 0) {
    strYear = (currentYear - minAge - year + 1).toString();
  }
  return strYear;
};

export const formatDate = (day, month, year) => `${year}-${month}-${day}`;
